<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px" max-height="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Aprovadores por grupo de documentos</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-select
                  v-model="grupoDocumentoUsuario.itemSelecionados"
                  :items="grupoDocumentoUsuario.usuarios"
                  label="Aprovadores"
                  item-text="nome"
                  item-value="id"
                  multiple
                  chips
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close"> Fechar </v-btn>
          <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import GrupoDocumentoUsuarioService from "@/common/services/http/grupoDocumentoUsuario.service";

export default {
  name: "GrupoDocumentoUsuarioDialog",
  props: {
    grupoDocumentoUsuario: Object,
    dialog: Boolean,
  },
  data: () => ({}),
  methods: {
    sync() {
      this.$emit("sync-dialog", { dialog: false });
    },
    close() {
      this.sync();
    },
    async save() {
      await GrupoDocumentoUsuarioService.save(
        this.grupoDocumentoUsuario.itemSelecionados.map((x) => ({
          usuarioID: x,
          grupoDocumentoID: this.grupoDocumentoUsuario.grupoDocumentoID,
        }))
      );
      this.sync();
    },
  },
};
</script>
